import { render, staticRenderFns } from "./HeaderBtn.vue?vue&type=template&id=42451a72&scoped=true&"
import script from "./HeaderBtn.vue?vue&type=script&lang=js&"
export * from "./HeaderBtn.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBtn.vue?vue&type=style&index=0&id=42451a72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42451a72",
  null
  
)

export default component.exports